export default "__VITE_ASSET__s7uIet9W__"